<template>
  <div style="    background: rgb(249, 250, 254);">
    <nav_list></nav_list>

    <div class="per">

      <div class="t1 bdall">
        <div class="tit1">

          {{ $lang(42340) }}

        </div>
        <div class="img1">
          <img :src="thumb ? thumb : '~@/../static/image/cover1.png'" alt="">
        </div>
        <div class="train">
          <span class="tit2">{{ $lang(42341) }} </span>
          <div class="con1" v-if="info.trainv.strs.sn">
            <span>{{info.trainv.strs.sn }} </span>
          </div>
        </div>
        <div class="txt1" v-if="cp_info" style="background:#fff;">
          <div class="text1">
            <span v-html="cp_info"> </span>
          </div>
        </div>
        <div class="txt1">
          <div class="text1">
            <span>{{ $lang(42376)}} </span><br>
            <span v-html="refund_plan"> </span>
          </div>
        </div>
      </div>

      <div class="t2">
        <div class="step1">
          <div class="con1">
            <img src="~@/../static/image/ok.png" alt="">
            <div class="y1">
              <span class="u1">{{ $lang(42342) }}</span><br>
              <span class="u2">{{ $lang(42343) }}</span>
            </div>
          </div>
          <div class="con1">
            <img src="~@/../static/image/step2.png" alt="">
            <div class="y1">
              <span class="u1">{{ $lang(42344) }}</span><br>
              <span class="u2">{{ $lang(42345) }}</span>
            </div>
          </div>
          <div class="con1">
            <img src="~@/../static/image/step3.png" alt="">
            <div class="y1">
              <span class="u1">{{ $lang(42346) }}</span><br>
              <span class="u2">{{ $lang(42347) }}</span>
            </div>
          </div>
        </div>

        <div class="channel">
          <div style="margin-left: 2%;">
            {{info.trainv.strs.title}}
          </div>
          <div class="screen">

            <div :class="'block1 trtagzz ' + tag.cls" v-for="(tag, j) in info.trainv.strs.tags" :key="j">


              <img class="incoimg" v-if="tag.icon" :src="tag.icon" /> <span> {{ tag.tit }}</span>

            </div>



          </div>
          <div class="lef btf_soll">
            <div class="ponts">
              <div class="bl " v-for="(pt, n) in info.trainv.strs.start_points" :key="pt.title"
                @click="show_point(pt.id)">
                {{ pt.title }} <br>
                {{ pt.time }}
              </div>
              <div class="bl yel " v-for="(pt, n) in info.trainv.strs.end_points" :key="pt.title"
                @click="show_point(pt.id)">
                {{ pt.title }}
                <br>
                {{ pt.time }}
              </div>
            </div>
          </div>
        </div>
        <div class="channel" v-if="info.trainv.use_spd_price == 0">

          <div style="margin-left: 2%;">
            {{$lang(44955)}}
          </div>
          <div class="lef btf_soll">
            <table class="lis_tab">
              <tr class="tit3">

                <td></td>
                <td class="yel bl_ft" v-for="(pt, n) in info.trainv.strs.end_points" :key="n"
                  @click="show_point(pt.id)">{{ pt.title }}</td>
              </tr>

              <tr class="tit3" v-for="(pt, n) in info.trainv.strs.start_points" :key="n + 'x'">
                <td class="bl bl_ft" @click="show_point(pt.id)">{{ pt.title }} </td>
                <td v-for="(ot, m) in info.trainv.strs.end_points" :key="m + 'y'" class="yel">
                  <span style="color:#000;"> {{p2p[pt.id][ot.id]['man_price']}} {{ $lang(42374) }} </span>

                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="sele1">
          <div class="y3">
            <div class="tit4">
              <span>{{ $lang(42348) }}</span>
            </div>
            <div class="ipt1">

              {{ info.date }}

            </div>
          </div>
          <div class="y3">
            <div class="tit4">
              <span>{{ $lang(42349) }}</span>
            </div>
            <div class="ipt1 pt_box">
              <el-select class="ipt" v-model="put.start_point_id" @change="update_man_price">
                <el-option v-for="(pt, n) in info.trainv.strs.start_points" :key="n" :label="pt.title + ' ' + pt.time"
                  :value="pt.id">
                </el-option>
              </el-select>
              <div class="pttti" @click="show_point(put.start_point_id)">

                <img src="/static/map.png" alt="">

              </div>


            </div>
          </div>

          <div class="y3">
            <div class="tit4">
              <span>{{ $lang(42350) }}</span>
            </div>
            <div class="ipt1 pt_box">
              <el-select class="ipt" v-model="put.end_point_id" @change="update_man_price">
                <el-option v-for="(pt, n) in info.trainv.strs.end_points" :key="n" :label="pt.title + ' ' + pt.time"
                  :value="pt.id">
                </el-option>
              </el-select>

              <div class="pttti" @click="show_point(put.end_point_id)">


                <img src="/static/map.png" alt="">

                </el-button>

              </div>

            </div>
          </div>
          <div class="stock" v-if="stock > -1">
            <div class="syyy">{{$lang(49499)}} <br />
              <span style="  color:  rgb(241, 27, 12);"> {{stock}} </span> {{$lang(49500)}}
            </div>

          </div>


        </div>




        <div class="notes" v-if="info.man_price != info.children_price">
          <div class="text3">
            <span> {{ $lang(42354) }}

            </span>
          </div>

        </div>

        <div class="people_info">
          <!-- 乘客基本信息 -->
          <div class="tit5">
            <span>{{ $lang(42355) }} </span>
          </div>

          <table class="put_user_list">
            <tr>
              <td style="width:16vw;">{{ $lang(42357) }}</td>
              <td style="width:16vw;"> {{ $lang(42356) }} </td>
              <td style="width:16vw;"> <span>{{ $lang(42360) }} / {{ $lang(42361) }} </span> </td>
              <td style="width:8vw;">
                {{ $lang(42493) }}

              </td>
            </tr>

            <tr v-for="(itm, i) in put.contacts " :key="i">
              <td class="tr_bot">
                <el-input v-model="put.contacts[i].name" :placeholder="$lang(42362)"></el-input>
              </td>
              <td class="tr_bot">
                <el-radio-group v-model="put.contacts[i].sex">

                  <el-radio class="ipt4" :label="1" v-if="!info.trainv.strs.only_f"> {{ $lang(42358) }}</el-radio>
                  <el-radio class="ipt4" :label="0"> {{ $lang(42359) }}</el-radio>
                </el-radio-group>
              </td>
              <td class="tr_bot">
                <el-input type="number" @change="age_change" max="120" min="0" v-model="put.contacts[i].age"
                  :placeholder="$lang(42363)">
                </el-input>

              </td>
              <td class="tr_bot  tr_botr">
                <span v-if="wait"> <i class="el-icon-loading"></i> {{$lang(50975)}}</span>
                <span v-else>{{itm.price}} {{ $lang(42374) }}</span>

                <el-button class="decc" size="mini" type="danger" icon="el-icon-delete" circle @click="del_contacts(i)">
                </el-button>

              </td>
            </tr>

            <tr>
              <!-- <td colspan="4"> </td>
              <td> </td>
              <td> </td> -->
              <td colspan="4" class="ddz222 ">
                <el-button type="success" class="add_ac_btn" size="mini" icon="el-icon-plus" @click="add_contacts">
                  {{$lang(50030)}}
                </el-button>





              </td>
            </tr>

          </table>
          <div class="contacts_boot">
          </div>

        </div>

        <!--  -->

        <!--  -->


        <!-- 联系 -->
        <div class="contact">
          <div class="sele1">
            <div class="y3">
              <div class="tit4">
                <span> <a style="color:red">*</a> {{ $lang(42366) }}</span>
              </div>
              <div class="ipt1">
                <el-input class="ipt" v-model="put.mail" :placeholder="$lang(42367)"
                  :readonly="Boolean(put.mail_status)"></el-input>
              </div>
            </div>

            <div class="y3">
              <div class="tit4">
                <span> {{ $lang(42364) }}</span>
              </div>
              <div class="ipt1">
                <el-input class="ipt" v-model="put.tel" :placeholder="$lang(42365)"></el-input>
              </div>
            </div>

            <div class="y3">
              <div class="tit4">
                <span> {{ $lang(42368) }}</span>
              </div>
              <div class="ipt1">
                <el-input class="ipt" v-model="put.wx_num" :placeholder="$lang(42369)"></el-input>
              </div>
            </div>

          </div>
          <div class="notes">
            <div class="text3">
              <span> {{ $lang(42370) }} </span>
            </div>
          </div>

        </div>





        <div class="up_down">

          <div class="btn" @click="smbt()">

            <span v-if="wait"> <i class="el-icon-loading"></i> {{ $lang(50975) }}</span>
            <span v-else> {{ total_price }}
              {{ $lang(42374) }} </span>

            <span class="bababax">{{ $lang(42373) }} </span>
          </div>
        </div>
      </div>
    </div>

    <point_tc :id="point_id" ref="pot_tc"> </point_tc>


  </div>
</template>

<script>
import nav_list from './nav_list.vue';
export default {
  name: "personal_info",
  components: {  //注册
    nav_list,
  },
  data() {
    let r = []

    // for (let i = 0; i < 50; i++) {
    //   r.push({
    //     name: '',
    //     sex: -1,
    //     age: '',
    //     price: 30,
    //   })
    // }
    // console.log(r)
    return {



      cp_info: '',
      thumb: '',
      refund_plan: '',

      timer : 60,
      vd_time : 0,
      id: 0,
      info: {
        trainv : {
          use_spd_price : 0,
          strs : {
            only_f : false
          }
        }
      },
      contacts: r,
      Company:{},
      stock: -1,
      man_price: 0,
      children_price: 0,
      wait : 0,
      put: {
        start_point_id: 0,
        end_point_id: 0,
        contacts: [
          {
            name: '',
            sex: -1,
            age: 0,
            price: 0,
          }
        ],
        total_price: 0,
        train_realtime_id: 0,
        train_price_id: 0,
        tel: '',
        mail: '',
        wx_num: '',
      },
      p2p: [],
      point_id: 0,
    };
  },
  mounted() {
    document.title = this.web_tit;
    this.id = this.cache('rtm_id')
    if (!this.id) {
      this.jump('/')
    }
    if (this.cache('put_' + this.id)) {
      this.put = this.cache('put_' + this.id)
    }
    this.put.train_realtime_id = this.cache('rtm_id')
    this.f5()
  },
  methods: {
    run_djs() {
      if (this.timer<= 0) {
        return this.get_new_info()

      }
      this.timer--

      setTimeout(() => {
        this.run_djs()
      }, 1000);
    },
    show_timer(){

        let m = parseInt((this.timer/60))
        let s = this.timer%60
        if (m < 10) {
          m = '0' + m
        }
        if (s < 10) {
          s = '0' + s
        }
        return m + ':' + s

    },
    show_point(id) {
      // alert(id)
      this.point_id = id
      this.$refs.pot_tc.f5(id)
    },
    add_contacts() {
      if (this.stock > -1 && this.put.contacts.length >= this.stock) {
        return this.$message(this.$lang(49501));

      }
      this.put.contacts.push({
        name: '',
        sex: -1,
        age: '',
        price: 0,
      })
      this.update_contacts_price()
    },
    update_contacts_price() {
      this.total_price = 0
      for (let i in this.put.contacts) {
        if (this.put.contacts[i].age <= 0 || this.put.contacts[i].age > 11) {
          this.put.contacts[i].price = this.man_price

        } else {
          this.put.contacts[i].price = this.children_price
        }
        this.total_price += this.put.contacts[i].price
        if (this.info.trainv.strs.only_f) {
          this.put.contacts[i].sex = 0
        }
      }
      this.total_price = this.decimal(this.total_price)
    },
    age_change(value) {
      this.update_contacts_price()

    },
    del_contacts(i) {
      this.put.contacts.splice(i, 1)
      this.update_contacts_price()
    },
    smbt() {
      if (this.stock > -1 && this.put.contacts.length >= this.stock) {
        return this.$message(this.$lang(49501));

      }
      for (let i in this.put.contacts) {
        if (this.put.contacts[i].sex == -1) {

          return this.$message(this.$lang('42355') + (i + 1) + '' + this.$lang(50031));
        }
        if (!this.put.contacts[i].name) {

          return this.$message(this.$lang('42355') + (i + 1) + '' + this.$lang(50033));
        }
        if (this.put.contacts[i].age <= 0) {

          return this.$message(this.$lang('42355') + (i + 1) + '' + this.$lang(50032));
        }
      }
      this.cache('put_' + this.id, this.put)
      this.get("/train/create_order", this.put, 'post').then((e) => {
        if (e.token) {

          this.cache('info', e.info);
          this.cache('token', e.token);
          this.$store.commit('login')
        }
        this.jump('/confirm_info?sn=' + e.sn)
      });
    },
    update_man_price() {
      if (this.info.trainv.use_spd_price == 0) {
        this.man_price = this.p2p[this.put.start_point_id][this.put.end_point_id]['man_price']
        this.stock = this.p2p[this.put.start_point_id][this.put.end_point_id]['stock']
        this.children_price = this.p2p[this.put.start_point_id][this.put.end_point_id]['children_price']
        this.update_contacts_price()
      }

    },
    get_new_info() {
      this.wait = 1

      this.get("/train/get_new_info", { id: this.id }, 'get', false).then((e) => {
        this.wait = 0
        this.timer = this.vd_time
        this.run_djs()
        if (e.info) {
          this.man_price = e.info.strs.man_price
          this.children_price = e.info.strs.children_price
        }

      })
    },
    f5() {
      this.get("/train/info", { id: this.id }).then((e) => {
        this.timer = this.vd_time = e.vd_time
        this.info = e.info
        this.Company = e.Company
        this.thumb = e.thumb
        this.cp_info = e.cp_info
        this.refund_plan = e.refund_plan
        this.cache('rtm_id', e.info.id)
        this.put.train_realtime_id = e.info.id
        this.man_price = this.info.strs.man_price
        if (e.info.strs.children_ticket) {
        	this.children_price = e.info.strs.children_price
        } else {
        	this.children_price = e.info.strs.man_price
        }
        // this.children_price = this.info.strs.children_price
        this.p2p = e.p2p
        // console.log(this.info.trainv)
        for (let i in this.info.trainv.strs.start_points) {
          this.put.start_point_id = this.info.trainv.strs.start_points[i].id
          break
        }
        for (let i in this.info.trainv.strs.end_points) {
          this.put.end_point_id = this.info.trainv.strs.end_points[i].id
          break
        }

        this.update_man_price()
        this.update_contacts_price()


        if (this.info.trainv.use_spd_price == 1) {

          if (this.info.strs.need_get == 1) {
            this.get_new_info()
          } else {
            this.run_djs()
          }

        }

        if (e.user) {
          this.put.tel = e.user.tel
          this.put.mail = e.user.mail
          this.put.wx_num = e.user.wx_num

          this.put.mail_status = Boolean(e.user.mail)
          // console.log(e.user.mail)
          // console.log(this.put.mail_status)
        }
      });
    },
  }
}
</script>

<style scoped>
.djs {
  position: fixed;
  z-index: 2;
  width :200px;
  min-height: 40px;
  background: #fff;
  left: 3%;
  bottom: 12%;
  border: 1px solid #F49847;
  border-radius: 5px;
  align-items: center;
  text-align: center;
  padding: 10px 0;

}
._dtit {
  color: #F49847;
  font-size: 13px;
}
._dtimer {
  font-size: 25px;
}
.pt_box {
  display: flex;
  align-items: center;
}

.pttti {
   
  margin-left: 4px;
}
.pttti img {
  width: 100%;
}

.contacts_boot {
  display: flex;
  justify-content: end;
  padding-right: 46px;
  margin-top: 10px;
  margin-bottom: 10px;
}


.put_user_list {
  border-spacing: 0px
}

.put_user_list td {
  padding: 10px;
  text-align: center;
  font-size: 13px;
  height: 40px;
}

.tr_bot {
  border-bottom: 1px solid #eee;
}

.tr_botr {
  text-align: right !important;
  padding-right: 50px !important;
}

.ddz222 {
  text-align: center;
}

decc {
  -left: 10px;
}
</style>
<style scoped>

.per {
  display: flex;
  margin-top: 2%;

}

/* 详细信息 */
.t1 {
  margin-left: 14%;
  width: 330px;
  height: 85vh;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
 
  border-radius: 10px;
}

.t1 .tit1 {
  width: 100%;
  height: 56px;
  line-height: 56px;
  background: rgb(4, 100, 221);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  text-align: center;
  color: rgb(255, 255, 255);
  font-family: Noto Sans SC;
  font-size: 18px;
  font-weight: 400;
}

.t1 .tit1 .info {
  display: flex;
  margin: 0 auto;
  width: 72px;
  color: rgb(255, 255, 255);
  font-family: Noto Sans SC;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0%;
}

.t1 .tit1 .info span {
  margin-top: 19%;
}

.t1 .img1 img {
  width: 330px;
  height: 191px;
}

.t1 .img1 img {
  width: 330px;
  height: 191px;
}

.t1 .train {
  display: flex;
  width: 100%;
  margin-bottom: 3%;
}

.t1 .train .tit2 {
  margin-right: 4%;
  margin-left: 6%;
  margin-top: 2%;
  color: rgb(4, 100, 221);
  font-family: Noto Sans SC;
  font-size: 18px;
  font-weight: 500;
  line-height: 27px;
  letter-spacing: 0%;
  text-align: center;
}

.t1 .train .con1 {
  margin-right: 2%;
  margin-top: 2%;
  color: rgb(33, 37, 41);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: 0%;
}

.t1 .txt1 {

  width: 100%;
  background: rgb(249, 250, 254);
  border-radius: 5px;
  width: 90%;
  padding: 5px;
  margin: auto;
  margin-bottom: 10%;
}

.t1 .txt1 .text1 {
  margin-left: 6%;
  margin-right: 6%;
  margin-top: 3%;
  margin-bottom: 3%;
  color: rgb(108, 117, 125);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0%;
  text-align: left;
}

.t2 {
  display: flex;
  flex-direction: column;
  margin-left: 2%;
}

.t2 .step1 {
  width: 58vw;
  height: 14vh;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
   box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);;
  border-radius: 10px;
  display: flex;
}

.t2 .step1 .con1 {
  flex: 0 0 33%;
  display: flex;
}

.t2 .step1 .con1 img {
  margin-left: 15%;
  margin-right: 5%;
  margin-top: 12%;
  width: 30px;
  height: 30px;
}

.t2 .step1 .con1 .y1 {
  margin-top: 12%;
}

.t2 .step1 .con1 .y1 .u1 {
  color: rgb(29, 33, 41);
  font-family: Noto Sans SC;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: left;
  font-weight: bold;
}

.t2 .step1 .con1 .y1 .u2 {
  color: rgb(134, 144, 156);
  font-family: Noto Sans SC;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: left;
}

.t2 .channel {
  margin-top: 1%;
  display: flex;
  flex-direction: column;
  width: 58vw;
  min-height: 25vh;
  box-sizing: border-box;
  padding: 20px 0px;
  background: rgb(255, 255, 255);
   box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);;
  border-radius: 10px;
}

.t2 .screen {
  margin-top: 2%;
  display: flex;
}

.t2 .channel .screen .block1 {
  background-color: rgb(249, 250, 254);
  color: #000;
  margin-left: 2%;
 
  height: 35px;
  line-height: 30px;

  display: flex;
  border-radius: 4px;
  padding: 0 10px;
    border-radius: 5px;
    background-color: rgba(239, 239, 239, 1);
    color: #6C6C6C;
    text-align: center;
}

.t2 .channel .screen .block1 .y2 {
  margin: 0 auto;
}

.t2 .channel .screen .block1 img {
  width: 18px;
  height: 18px;

}

.t2 .channel .screen .block1 span {

  font-family: Noto Sans SC;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0%;
}

.t2 .channel .lef {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 3%;
  margin-left: 2%;
}

.t2 .channel .lef .lis_tab {
  text-align: center;
  border-spacing: 0px;
}

.t2 .channel .lef .lis_tab .tit3 {
  color: rgb(4, 100, 221);
}

.t2 .sele1 {
  margin-top: 1%;
  width: 58vw;
  height: 15vh;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
   box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);;
  border-radius: 10px;
  display: flex;
}

.t2 .sele1 .y3 {
  flex: 0 0 25%;
  margin-top: 3%;
  margin-left: 3%;
}

.t2 .sele1 .stock {
  flex: 0 0 10%;
  margin-left: 3%;
  height: 15vh;
  align-items: center;

  font-weight: bold;

}

.t2 .sele1 .syyy {

  margin-top: 5.5vh;
  ;


}

.t2 .sele1 .y3 .tit4 span {
  color: rgb(66, 84, 134);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0%;
  text-align: center;

}

.t2 .sele1 .y3 .ipt1 {
  margin-top: 2%;
}

.t2 .sele1 .y3 .ipt1 .ipt {
  width: 15vw;
}

.t2 .people_sele {
  margin-top: 1%;
  width: 58vw;
  height: 14vh;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
   box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);;
  border-radius: 10px;
  display: flex;
}

.t2 .people_sele .y4 {
  margin-left: 3%;
  margin-top: 3%;
  flex: 0 0 40%;
}

.t2 .people_sele .y4 .tit4 {
  color: rgb(66, 84, 134);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0%;
}

.t2 .people_sele .y4 .ipt2 {
  margin-top: 2%;
}

.t2 .people_sele .y4 .ipt2 .sub_tit {
  color: rgb(108, 117, 125);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0%;
  margin-right: 5%;
}

.t2 .people_sele .y4 .ipt2 .xh {
  color: rgb(108, 117, 125);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
  letter-spacing: 0%;
  margin-right: 5%;
  margin-left: 5%;
}

.t2 .notes {

  width: 58vw;

  box-sizing: border-box;


}

.t2 .notes .text3 {
  margin-top: 1%;
  line-height: 30px;
  min-height: 30px;
  
  border-radius: 10px;
  align-items: center;
background-color: rgba(0, 0, 0, 0.05);
    color: rgba(16, 16, 16, 0.9);
  padding: 10px;


}
 

.t2 .people_info {
  width: 58vw;
  margin-top: 1%;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
   box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

.t2 .people_info .r1 {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 2%;
}

.t2 .people_info .tit5 {
  margin-top: 2%;
  margin-left: 18px;
  color: rgb(33, 37, 41);
  font-family: Noto Sans SC;
  font-size: 20px;
  font-weight: 500;
  line-height: 40px;
  letter-spacing: 0%;
  border-bottom: 1px solid #eee;
}

.t2 .people_info .r1 .info2 {
  width: 100%;
  display: flex;
}

.t2 .people_info .r1 .info2 .block3 {
  flex: 0 0 25%;
  align-items: center;

}

.t2 .people_info .r1 .btnn {
  flex: 0 0 5%;

  height: 73px;
  line-height: 100px;
  align-items: center;
}

.t2 .people_info .r1 .info2 .block3 .sub_tit2 {
  color: rgb(66, 84, 134);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0%;
  margin-top: 2%;
  margin-left: 7%;

}

.t2 .people_info .r1 .block3 .ipt3 {
  color: rgb(66, 84, 134);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 40px;
  height: 40px;
  letter-spacing: 0%;
  margin-top: 2%;
  margin-left: 7%;

}

.t2 .people_info .r1 .block3 .ipt3 .ss {
  color: rgb(108, 117, 125);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0%;
  margin-left: 3%;
  margin-top: 2%;

}

.t2 .people_info .r1 .block3 .ipt3 .iptpricex {
  color: rgb(108, 117, 125);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0%;
  margin-left: 3%;


}

.t2 .people_info .r1 .block3 .ipt3 .ipt4 {
  width: 20%;
  margin-top: 4%;
}


.t2 .total_amount {
  width: 58vw;
  height: 8.5vh;
  margin-top: 1%;
  box-sizing: border-box;
  background: rgb(255, 247, 237);
  border: 1px solid rgb(247, 175, 72);
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.t2 .total_amount .text4 {
  color: rgb(208, 126, 9);
  font-family: Noto Sans SC;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0%;
}

.t2 .total_amount .total {
  color: rgb(255, 121, 0);
  font-family: Noto Sans SC;
  font-size: 28px;
  font-weight: 700;
  line-height: 41px;
  letter-spacing: 0%;
  margin-right: 5%;
}

.t2 .up_down {
    margin: 10px 0;
    border-radius: 10px;
    background-color: rgba(0, 166, 250, 1);
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);
    text-align: center;
    padding: 10px 20px;
    color: #fff;
    cursor: pointer;
}

 

.t2 .up_down  .bababax {
   margin-left: 30px;
}

.ponts {
  display: flex;
  align-items: center;
  width: 100%;
  text-align: center;
  font-weight: bold;
}

.bl {
  padding: 10px 10px;
  box-sizing: border-box;
  background: #E8F3FF;
  border-radius: 5px;
  color: #175EFF;
  margin-right: 10px;
  font-size: 14px;

}

.yel {

  background: #FFF7E9;
  color: #FE7D00;
}

.add_ac_btn {
  
    
    border-radius: 10px;
    background-color: rgba(80, 162, 248, 1);
    color: rgba(255, 255, 255, 1);
    font-size: 16px;
    text-align: center;
    border: 0px;
    box-shadow: 0px 2px 6px 0px rgba(57, 90, 246, 0.5);
 
}

.ddz222 {
  text-align: left !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/personal_info.vue